// extracted by mini-css-extract-plugin
module.exports = {"pintxo-avatar":"Avatar_pintxo-avatar__fszb8","pintxo-avatar__shape":"Avatar_pintxo-avatar__shape__mC6AT","pintxo-avatar__shape__text":"Avatar_pintxo-avatar__shape__text__hZzGG"};